<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasStore="true"
      :hasCustomer="true"
      :hasEmployee="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    ></condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["statistic", "detail"],
      reportType: "statistic",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "detail") {
        return [
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "BusinessDay" },
          { name: "SalNumber" },
          { name: "TradeType" },
          { name: "SalTime" },
          { name: "Total" },
          { name: "IntegralAdd" },
          { name: "IntegralMinus" },
          { name: "Integral" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "SalerNumber" },
          { name: "SalerName" },
        ];
      } else {
        return [
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "Total" },
          { name: "IntegralAdd" },
          { name: "IntegralMinus" },
        ];
      }
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getIntegral(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getIntegral(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printIntegral(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;

      const vm = this;
      this.$api.reports.getIntegral(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
